import { styled } from "@mui/material";

export const StyledGameDate = styled("span")`
  color: ${({ theme }) => theme.wsc.palette.neutral[200]};
  ${({ theme }) => theme.wsc.typography.body2};
`;
